import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../helpers/config.service';
import { TokenStorageService } from '../services/token-storage.service'

/* const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json',
  'Authorization': 'Bearer '+''
})
};*/
@Injectable({
  providedIn: 'root'
})

export class AuthService {

  

  constructor(private http: HttpClient, private config: ConfigService, private tokenstorge: TokenStorageService) { }

  

  login(email: string, password: string): Observable<any> {
    return this.http.post( this.config.phat+"login", { email, password });
  }

  register(username: string, email: string, password: string): Observable<any> {
    return this.http.post(this.config.phat + 'register', {
      username,
      email,
      password
    });
  }


  logout(): Observable<any>{

     console.log("se deslogueo");
     let token = this.tokenstorge.getToken();

      console.log(token);
      
    let httpOptions = {
      headers: new HttpHeaders({'Authorization': 'Bearer '+token})
     };
     
      // aqui preparamos poara la cabecer
    return this.http.post(this.config.phat+'logout', null, httpOptions);
  }


  bitacora(params:any){
    let url = 'bitacora';
    let token = this.tokenstorge.getToken();
    let httpOptions = {
      headers: new HttpHeaders({'Authorization': 'Bearer '+token})
    };
    return this.http.post(this.config.phat+url, params, httpOptions);
  }


}
